import { render, staticRenderFns } from "./InventoryDownload.vue?vue&type=template&id=b3ae117c&scoped=true&"
import script from "./InventoryDownload.vue?vue&type=script&lang=js&"
export * from "./InventoryDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ae117c",
  null
  
)

export default component.exports